export const SET_USER_FAVORITES_LOADED = "SET_USER_FAVORITES_LOADED";

export const setUserFavoritesLoaded = (userFavoritesLoaded: boolean) => {
  return {
    userFavoritesLoaded,
    // tslint:disable-next-line:object-literal-sort-keys
      type: SET_USER_FAVORITES_LOADED
  };
};
